import React, { Component } from "react";
import { Row, Col, Button } from "reactstrap";
import { connect } from "react-redux";
import {
  getCompanySchedule,
  saveCompanySchedule,
  saveCompanyScheduleName,
  updateScheduleName,
  deleteSchedule,
  makeAsDefault,
  duplicate,
} from "../../../../actions/scheduleActions";
import Availability from "./Components/Availability";
import { Formik, Form } from "formik";
import Loader from "../../../../components/Loader/Loader";
import AddScheduleModal from "./Components/AddScheduleModal";
import DeleteScheduleModal from "./Components/DeleteScheduleModal";
import EditScheduleModal from "./Components/EditScheduleModal";
import SetAsDefaultModal from "./Components/SetAsDefaultModal";

import {
  getAdminBusinessId,
  getLoggedInUserId,
} from "../../../../utils/authHelper";
import { notification } from "../../../../utils/utility";
import ListScheduleTemplates from "./Components/ListScheduleTemplates";

class Company extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      pageLoading: false,
      schedules: [],
      availabilities: [],
      activeTab: "1",
      listSchedules: [],
      showAddScheduleModal: false,
      selectedScheduleId: null,
      selectedScheduleName: null,
      selectedScheduleIsDefaultOne: false,
      scheduleListDropDownStatus: false,
      timezoneId: null,
      showEditScheduleModal: false,
      scheduleName: "",
      scheduleId: "",
      showDeleteScheduleModal: false,
      settingsDropdownStatus: false,
      showSetAsDefaultModal: false,
    };
  }

  componentDidMount() {
    const { getCompanySchedule, onRegisterAddHandler } = this.props;

    // Register the "New Schedule" handler so index.js can trigger it
    if (onRegisterAddHandler) {
      onRegisterAddHandler(this.onAddScheduleHandle);
    }

    const _this = this;

    _this.setState({
      pageLoading: true,
    });

    getCompanySchedule({
      data: {
        scheduleId: null,
      },
      onSuccess: function (response) {
        _this.setState({
          pageLoading: false,
          listSchedules: response.listSchedules,
          selectedScheduleId: response.schedules ? response.schedules.id : null,
          selectedScheduleName: response.schedules
            ? response.schedules.schedule_name
            : null,
          selectedScheduleIsDefaultOne: response.schedules
            ? response.schedules.is_default === "E"
              ? true
              : false
            : false,
        });
        _this.setSchedules(
          _this.processSchedulesForListView(response.schedules),
          response.schedules ? response.schedules.timezone_id : ""
        );
      },
      onError: function (error) {
        _this.setState({
          pageLoading: false,
        });
      },
    });
  }

  /**
   * hide edit schedule modal
   */
  hideEditScheduleModal = () => {
    this.setState({
      showEditScheduleModal: false,
    });
  };

  /**
   * Update schedule
   * @param {*} scheduleId
   * @param {*} schduleName
   */
  updateScheduleTemplateName = (scheduleId, schduleName) => {
    const _this = this;

    const { updateScheduleName } = _this.props;
    const listSchedulesNames = [..._this.state.listSchedules];

    let scheduleToUpdate = listSchedulesNames.find(
      (schedule) => schedule.id === scheduleId
    );

    if (scheduleToUpdate.is_business_hours === "E") {
      return notification.warning("Cant update business hours template name");
    }

    _this.setState({
      pageLoading: true,
    });

    updateScheduleName({
      data: {
        id: scheduleId,
        schedule_name: schduleName,
      },
      onSuccess: function (response) {
        const updatedScheduleIndex = listSchedulesNames.findIndex(
          (el) => el.id === scheduleId
        );
        listSchedulesNames[updatedScheduleIndex].schedule_name = schduleName;
        _this.setState({
          pageLoading: false,
          listSchedules: listSchedulesNames,
        });
        notification.success("Schedule Name successfully Updated");
      },
      onError: function (error) {
        _this.setState({
          pageLoading: false,
        });
        notification.error("An error occured during update, please try later");
      },
    });
  };

  /**
   * set schedule as default
   * @param {*} scheduleId
   */
  setAsDefaultHandle = (scheduleId) => {
    const _this = this;

    const { makeAsDefault } = _this.props;

    const listSchedules = [..._this.state.listSchedules];

    _this.setState({
      pageLoading: true,
    });

    makeAsDefault({
      data: {
        id: scheduleId,
        business_id: getAdminBusinessId(),
      },
      onSuccess: function (response) {
        notification.success("Record saved successfully");

        const disableDefaultScheduleIndex = listSchedules.findIndex(
          (schedule) => schedule.is_default == "E"
        );

        if (disableDefaultScheduleIndex !== -1) {
          listSchedules[disableDefaultScheduleIndex].is_default = "D";
        }

        const scheduleIndex = listSchedules.findIndex(
          (schedule) => schedule.id == scheduleId
        );

        if (scheduleIndex !== -1) {
          listSchedules[scheduleIndex].is_default = "E";
          listSchedules.push(...listSchedules.splice(0, scheduleIndex));
        }

        // set first default template and then second as business hours
        let updatedScheduleNames = [];

        const defaultSchedule = listSchedules.find(
          (schedule) => schedule.is_default === "E"
        );

        const businessHoursSchedule = listSchedules.find(
          (schedule) => schedule.is_business_hours === "E"
        );

        if (
          defaultSchedule &&
          businessHoursSchedule &&
          defaultSchedule.id === businessHoursSchedule.id
        ) {
          updatedScheduleNames.push(defaultSchedule);
        } else {
          updatedScheduleNames.push(defaultSchedule);
          updatedScheduleNames.push(businessHoursSchedule);
        }

        listSchedules.forEach((schedule, index) => {
          if (
            schedule.is_default !== "E" &&
            schedule.is_business_hours !== "E"
          ) {
            updatedScheduleNames.push(schedule);
          }
        });

        _this.setState({
          pageLoading: false,
          listSchedules: updatedScheduleNames,
        });
      },
      onError: function (error) {
        notification.error("An error occured during save, please try later");
        _this.setState({
          pageLoading: false,
        });
      },
    });
  };

  /**
   * on clone schedule
   */
  onClone = () => {
    const _this = this;

    const { selectedScheduleId } = _this.state;
    const { duplicate, getCompanySchedule } = _this.props;

    _this.setState({
      pageLoading: true,
    });

    duplicate({
      data: {
        id: selectedScheduleId,
      },
      onSuccess: function (response) {
        notification.success("Record cloned successfully");

        console.log("response clone", response);

        const { data } = response.data;

        const listSchedules = [..._this.state.listSchedules];

        if (listSchedules.length > 3) {
          const temp = listSchedules[2];
          listSchedules[2] = {
            id: data.id,
            schedule_name: data.schedule_name,
          };
          listSchedules.push(temp);
        } else {
          listSchedules.push({
            id: data.id,
            schedule_name: data.schedule_name,
          });
        }

        _this.setState({
          listSchedules,
        });

        getCompanySchedule({
          data: {
            scheduleId: data.id,
          },
          onSuccess: function (response) {
            _this.setState({
              pageLoading: false,
              listSchedules: listSchedules,
            });

            if (response.schedules) {
              _this.setState({
                selectedScheduleId: response.schedules.id,
                selectedScheduleName: response.schedules.schedule_name,
                selectedScheduleIsDefaultOne:
                  response.schedules.is_default === "E" ? true : false,
              });
              _this.setSchedules(
                _this.processSchedulesForListView(response.schedules),
                response.schedules ? response.schedules.timezone_id : ""
              );
            }
          },
          onError: function (error) {
            _this.setState({
              pageLoading: false,
            });
          },
        });
      },
      onError: function (error) {
        notification.error("An error occured during clone, please try later");
        _this.setState({
          pageLoading: false,
        });
      },
    });
  };

  /**
   * Update schedule
   * @param {*} scheduleId
   */
  deleteScheduleTemplate = (scheduleId) => {
    const _this = this;

    const { deleteSchedule } = _this.props;

    const listSchedulesNames = [..._this.state.listSchedules];

    _this.setState({
      pageLoading: true,
    });

    deleteSchedule({
      data: {
        id: scheduleId,
        business_id: getAdminBusinessId(),
      },
      onSuccess: function (response) {
        const scheduleToDelete = listSchedulesNames.find(
          (schedule) => schedule.id === scheduleId
        );

        let processedScheduleNames = null;

        if (scheduleToDelete.is_default === "E") {
          // make business hours as default one
          const newListSchedules = listSchedulesNames.map((sch) =>
            sch.is_business_hours === "E" ? { ...sch, is_default: "E" } : sch
          );
          processedScheduleNames = newListSchedules.filter(
            (el) => el.id !== scheduleId
          );
        } else {
          processedScheduleNames = listSchedulesNames.filter(
            (el) => el.id !== scheduleId
          );
        }

        notification.success("Schedule template successfully Deleted");
        _this.setState({
          pageLoading: false,
          listSchedules: processedScheduleNames,
        });

        processedScheduleNames.forEach((schedule, index) => {
          if (schedule.is_default === "E") {
            _this.loadSchedule(schedule.id);
          }
        });
      },
      onError: function (error) {
        notification.error("An error occured during delete, please try later");
        _this.setState({
          pageLoading: false,
        });
      },
    });
  };

  /**
   * show Edit schedule modal
   * @param {*} scheduleId
   * @param {*} scheduleName
   */
  showEditScheduleModal = (scheduleId, scheduleName) => {
    this.setState({
      scheduleId,
      scheduleName,
      showEditScheduleModal: true,
    });
  };

  /**
   * hide add schedule modal
   */
  hideAddScheduleModal = () => {
    this.setState({
      showAddScheduleModal: false,
    });
  };

  /**
   * show modal for add schedule
   */
  onAddScheduleHandle = () => {
    this.setState({
      showAddScheduleModal: true,
    });
  };

  /**
   * hide add schedule modal
   */
  hideDeleteScheduleModal = () => {
    this.setState({
      showDeleteScheduleModal: false,
    });
  };

  /**
   * hide set as default modal
   */
  hideSetAsDefaultModal = () => {
    this.setState({
      showSetAsDefaultModal: false,
    });
  };

  /**
   * show modal for add schedule
   */
  showDeleteScheduleHandle = (scheduleId) => {
    const _this = this;
    const listSchedulesNames = [..._this.state.listSchedules];

    const scheduleToDelete = listSchedulesNames.find(
      (schedule) => schedule.id === scheduleId
    );

    if (scheduleToDelete && scheduleToDelete.is_business_hours === "E") {
      return notification.warning("Cant delete business hours template");
    }

    /*
    if (scheduleToDelete.length && scheduleToDelete.is_default === "E") {
      return notification.warning("Cant delete default template");
    }
    */

    this.setState({
      showDeleteScheduleModal: true,
      scheduleId,
    });
  };

  /**
   * show modal to confirm set as default
   * @param {*} scheduleId
   */
  showMakeAsDefaultHandle = (scheduleId) => {
    this.setState({
      showSetAsDefaultModal: true,
      scheduleId,
    });
  };

  /**
   * load schedule
   * @param {*} scheduleId
   */
  loadSchedule = (scheduleId) => {
    const _this = this;

    const { getCompanySchedule } = _this.props;

    _this.setState({
      pageLoading: true,
    });

    getCompanySchedule({
      data: {
        scheduleId,
      },
      onSuccess: function (response) {
        _this.setState({
          pageLoading: false,
        });

        if (response.schedules) {
          _this.setState({
            selectedScheduleId: response.schedules.id,
            selectedScheduleName: response.schedules.schedule_name,
            selectedScheduleIsDefaultOne:
              response.schedules.is_default === "E" ? true : false,
          });
          _this.setSchedules(
            _this.processSchedulesForListView(response.schedules),
            response.schedules ? response.schedules.timezone_id : ""
          );
        }
      },
      onError: function (error) {
        _this.setState({
          pageLoading: false,
        });
      },
    });
  };

  /**
   * save new schedule
   */
  saveNewSchedule = (scheduleName) => {
    const _this = this;
    const { saveCompanyScheduleName, getCompanySchedule } = _this.props;

    _this.setState({
      pageLoading: true,
    });

    const data = {
      business_id: getAdminBusinessId(),
      schedule_name: scheduleName,
    };

    saveCompanyScheduleName({
      data,
      onSuccess: function (response) {
        notification.success("Schedule added successfully");

        const { data } = response.data;

        const listSchedules = [..._this.state.listSchedules];

        listSchedules.push({
          id: data.id,
          schedule_name: data.schedule_name,
          is_default: data.is_default,
        });

        getCompanySchedule({
          data: {
            scheduleId: data.id,
          },
          onSuccess: function (response) {
            _this.setState({
              pageLoading: false,
              listSchedules: listSchedules,
            });

            if (response.schedules) {
              _this.setState({
                selectedScheduleId: response.schedules.id,
                selectedScheduleName: response.schedules.schedule_name,
                selectedScheduleIsDefaultOne:
                  response.schedules.is_default === "E" ? true : false,
              });
              _this.setSchedules(
                _this.processSchedulesForListView(response.schedules),
                response.schedules ? response.schedules.timezone_id : ""
              );
            } else {
              _this.setState({
                timezoneId: "",
              });
            }
          },
          onError: function (error) {
            console.log("error", error);
            _this.setState({
              pageLoading: false,
            });
          },
        });
      },
      onError: function (error) {
        _this.setState({
          pageLoading: false,
        });
        const { data } = error?.response;
        if (data.code === 256) {
          notification.warning(data.data.message);
        } else {
          notification.error("An error during save, please try later");
        }
      },
    });
  };

  /**
   * @param Array schedules
   * @return Array
   */
  processSchedulesForListView = (schedules) => {
    let processedSchedules = [];
    (schedules.schedule_details || []).forEach((scheduleDetail) => {
      if (scheduleDetail.type == "weekly") {
        processedSchedules.push({
          dayId: parseInt(scheduleDetail.weekday_id),
          schedules: [...scheduleDetail.schedule_availability],
        });
      }
    });

    return processedSchedules;
  };

  /**
   * process schedules to save in database
   * @param int eventId
   * @returns array
   */
  processScheduleForSave = () => {
    const { schedules } = this.state;

    let processedSchedules = [];
    schedules.forEach((schedule, index) => {
      const weekDayId = schedule.hasOwnProperty("dayId")
        ? schedule.dayId
        : null;
      const dated = schedule.hasOwnProperty("dated") ? schedule.dated : null;

      const type = schedule.hasOwnProperty("dated") ? "custom" : "weekly";

      processedSchedules.push({
        weekday_id: weekDayId,
        dated: dated,
        on_status: "E",
        type: type,
        schedule_availability: (schedule.schedules || []).filter(
          (slot) => slot && slot.start_time && slot.end_time
        ),
      });
    });

    return processedSchedules;
  };

  /**
   * on save
   */
  onSave = () => {
    const _this = this;

    const { saveCompanySchedule } = _this.props;
    const processedSchedules = _this.processScheduleForSave();

    console.log("process", processedSchedules);

    _this.setState({
      isLoading: true,
      //pageLoading: true,
    });

    let newData = {
      provider_id: getLoggedInUserId(),
      schedule_id: _this.state.selectedScheduleId,
      timezone_id: _this.state.timezoneId,
      business_id: getAdminBusinessId(),
      schedule_details: processedSchedules,
    };

    saveCompanySchedule({
      data: {
        ...newData,
      },
      onSuccess: () => {
        _this.setState({
          isLoading: false,
          //pageLoading: false,
        });
        notification.success("Company schedule saved successfully");
      },
      onError: (error) => {
        _this.setState({
          isLoading: false,
          //pageLoading: false,
        });
      },
    });
  };

  /**
   *
   * @param Array updatedSchedules
   * @param mixed timezoneId
   */
  setSchedules = (updatedSchedules, timezoneId) => {
    console.log("set schedule is called");
    this.setState({
      schedules: updatedSchedules,
      timezoneId: timezoneId,
    });
  };

  /**
   * on toggle active tab
   * @param {*} tab
   */
  onToggleActiveTab = (tab) => {
    this.setState({
      activeTab: tab,
    });
  };

  /**
   * toggle schedule list drop down
   */
  toggleScheduleListDropdown = () => {
    this.setState((prevState) => ({
      scheduleListDropDownStatus: !prevState.scheduleListDropDownStatus,
    }));
  };

  /**
   * toggle setting drop down
   */
  toggleSettingListDropdown = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState((prevState) => ({
      settingsDropdownStatus: !prevState.settingsDropdownStatus,
    }));
  };

  /**
   *
   * @param {*} schedules
   */
  setListSchedules = (listSchedules) => {
    this.setState({
      listSchedules,
    });
  };

  render() {
    const _this = this;
    const {
      pageLoading,
      isLoading,
      activeTab,
      listSchedules,
      showAddScheduleModal,
      selectedScheduleId,
      selectedScheduleName,
      scheduleListDropDownStatus,
      showEditScheduleModal,
      scheduleName,
      scheduleId,
      showDeleteScheduleModal,
      settingsDropdownStatus,
      showSetAsDefaultModal,
      selectedScheduleIsDefaultOne,
      selectedTimezoneId,
    } = this.state;
    return (
      <>
        <Loader isShowLoader={pageLoading} />

        {showAddScheduleModal && (
          <AddScheduleModal
            showAddScheduleModal={showAddScheduleModal}
            hideAddScheduleModal={this.hideAddScheduleModal}
            saveNewSchedule={this.saveNewSchedule}
          />
        )}

        {showEditScheduleModal && (
          <EditScheduleModal
            showEditScheduleModal={showEditScheduleModal}
            hideEditScheduleModal={this.hideEditScheduleModal}
            scheduleName={scheduleName}
            scheduleId={scheduleId}
            updateScheduleTemplateName={this.updateScheduleTemplateName}
          />
        )}

        {showDeleteScheduleModal && (
          <DeleteScheduleModal
            showDeleteScheduleModal={showDeleteScheduleModal}
            hideDeleteScheduleModal={this.hideDeleteScheduleModal}
            scheduleId={scheduleId}
            deleteScheduleTemplate={this.deleteScheduleTemplate}
          />
        )}

        {showSetAsDefaultModal && (
          <SetAsDefaultModal
            showSetAsDefaultModal={showSetAsDefaultModal}
            hideSetAsDefaultModal={this.hideSetAsDefaultModal}
            scheduleId={scheduleId}
            setAsDefaultHandle={this.setAsDefaultHandle}
          />
        )}

        <ListScheduleTemplates
          listSchedules={listSchedules}
          loadSchedule={this.loadSchedule}
          selectedScheduleId={selectedScheduleId}
          settingsDropdownStatus={settingsDropdownStatus}
          selectedScheduleName={selectedScheduleName}
          selectedScheduleIsDefaultOne={selectedScheduleIsDefaultOne}
          scheduleListDropDownStatus={scheduleListDropDownStatus}
          toggleSettingListDropdown={this.toggleSettingListDropdown}
          showEditScheduleModal={this.showEditScheduleModal}
          onClone={this.onClone}
          showMakeAsDefaultHandle={this.showMakeAsDefaultHandle}
          showDeleteScheduleHandle={this.showDeleteScheduleHandle}
          toggleScheduleListDropdown={this.toggleScheduleListDropdown}
          setListSchedules={this.setListSchedules}
          onAddSchedule={this.onAddScheduleHandle}
        />

        {listSchedules.length > 0 && (
          <Col md="12" lg="12">
            <div className="event-card">
              <div className="event-card-head">
                <Row className="w-100">
                  <Col md="12" lg="12">
                    <h3 className="event-title">
                      {selectedScheduleName || "Schedule"}
                    </h3>
                    <p className="sch-editor-sub">
                      {selectedScheduleIsDefaultOne
                        ? "Your default weekly availability"
                        : "Weekly availability for this schedule"}
                    </p>
                  </Col>
                </Row>
              </div>
              <div className="event-card-body pt-0">
                <div className="event-field-group border-zero">
                  <div className="availbility-container">
                    <Formik
                      onSubmit={(data) => {}}
                      initialValues={{ availbility: "" }}
                    >
                      {(formProps) => {
                        const { values, errors, touched, handleChange } =
                          formProps;
                        return (
                          <Form>
                            <Availability
                              onToggleActiveTab={this.onToggleActiveTab}
                              errors={[]}
                              touched={[]}
                              schedules={this.state.schedules}
                              timezoneId={this.state.timezoneId}
                              setSchedules={this.setSchedules}
                            />
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                  {activeTab == "1" ? (
                    <div className="sch-editor-footer">
                      <button
                        disabled={isLoading}
                        type="button"
                        className="sch-save-btn"
                        onClick={this.onSave}
                      >
                        {isLoading ? "Saving..." : "Save changes"}
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </Col>
        )}
      </>
    );
  }
}

export default connect(null, {
  getCompanySchedule,
  saveCompanySchedule,
  saveCompanyScheduleName,
  updateScheduleName,
  deleteSchedule,
  makeAsDefault,
  duplicate,
})(Company);
